//Generated File 
export default class SoundEffects{
	static readonly None = `None`;
	static readonly Sound1 = `Sound1`;
	static readonly Sound2 = `Sound2`;
	static readonly Sound3 = `Sound3`;
	static readonly Sound4 = `Sound4`;
	static readonly Sound5 = `Sound5`;
}
